export default __webpack_public_path__ + "static/highlight-connect-768af6426833cfdb10283851e068f450.png";